var map = {
	"./dice-1.webp": 235,
	"./dice-2.webp": 8683,
	"./dice-3.webp": 5352,
	"./dice-4.webp": 980,
	"./dice-5.webp": 5548,
	"./dice-6.webp": 7108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5418;